import PhotoSwipe from '../../../node_modules/photoswipe'
import PhotoSwipeUIDefault from '../../../node_modules/photoswipe/dist/photoswipe-ui-default.min'

class Gallery {
  constructor () {
    this.pswpElement = document.querySelectorAll('.pswp')[0]
    this.options = {
      index: 0, // start at first slide
      shareEl: false
    }
    this.images = []
  }

  init (images, startIndex = 0) {
    this.images = images
    this.options.index = startIndex
  }

  show () {
    let gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUIDefault, this.images, this.options)
    gallery.listen('gettingData', function (index, item) {
      let image = new Image()
      image.src = item.src
      item.w = image.width
      item.h = image.height
    })
    gallery.init()
  }
}

export const gallery = function (images = [], startIndex = 0) {
  if (!images.length) return
  let gallery = new Gallery()
  gallery.init(images, startIndex)
  gallery.show()
}



// WEBPACK FOOTER //
// ./src/public-lib/vue-components/src/components/c-gallery/index.js